import React from 'react';
import './TempleHistoryModal.css';

function TempleHistoryModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const templeHistory = `Sri Lakshmi Venkateshwara Swamy Temple, GPR Grande Layout, Chandapura

The G.P.R. Grande Sri Lakshmi Venkateshwara Temple Trust (R) successfully organized the Prana Pratishthapana Mahotsava from 16th to 18th August 2025. The three-day celebration was marked by grand Vedic rituals, homas, abhishekas, cultural programs, and daily prasadam distribution.

As part of the Mahotsava, the new Shila Bimbas of Lord Venkateshwara, Goddess Lakshmi Padmavathi Devi, and Lord Maha Ganapathi were installed with traditional ceremonies. Thousands of devotees participated with great devotion, and the entire event created a divine and festive atmosphere in GPR Layout, Chandapura.

The Trust expressed gratitude to all residents, devotees, and volunteers for their active participation and support in making the Mahotsava a grand success.

"Peaceful and divine temple at GPR Layout, Chandapura. Well-maintained, with positive vibrations and a blessed darshan of Sri Lakshmi Venkateshwara Swamy. Special poojas and cultural events here bring the community together."

A must-visit for devotees in the area.`;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose} aria-label="Close">
          <i className="fas fa-times"></i>
        </button>
        <div className="modal-header">
          <h2>Temple History</h2>
          <p className="modal-subtitle">GPR Grande Sri Lakshmi Venkateshwara Temple</p>
        </div>
        <div className="modal-body">
          {templeHistory.split('\n\n').map((paragraph, index) => (
            <p key={index} className="history-paragraph">
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TempleHistoryModal;
